import React, { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

type Props = React.InputHTMLAttributes<HTMLInputElement>;
const TextInput = forwardRef(
  ({ className, ...rest }: Props, ref: React.Ref<HTMLInputElement>) => {
    return (
      <input
        ref={ref}
        className={twMerge(
          "block w-full rounded-lg border-0 bg-white p-2 text-black shadow-sm ring-1 ring-inset ring-brand-deepaqua placeholder:text-slate-400 focus:ring-1 focus:ring-inset focus:ring-brand-deepaqua",
          className
        )}
        {...rest}
      />
    );
  }
);

TextInput.displayName = "TextInput";

export default TextInput;
